import { visibleSurfaces, type Surface } from "@csa/web-foundation";
import type { MessageKey } from "../i18n/dictionaries";

// The admin console's surface registry (App Layer Charter §1; AL1). The per-app list
// handed to the foundation shell. Each surface declares the grant that makes it
// visible — the foundation computes the nav from the principal. The API still
// enforces every call (this is UX). AL2 (commission-rate) and AL3 (config governance)
// add their surfaces here. `labelKey` is typed against the admin dictionary.
export const SURFACES: Surface<MessageKey>[] = [
  {
    // 04 — Yönetim Paneli (management home). An analytics-grade overview: KPI reads,
    // the carrier-quality roster, governed-approval inbox. Gated on the management
    // analytics grant; every card's read re-enforces its own grant server-side.
    key: "dashboard",
    path: "/panel",
    labelKey: "nav.dashboard",
    requires: { permission: "analytics:read", scope: "all" },
  },
  {
    key: "catalog",
    path: "/catalog/carrier-quality",
    labelKey: "nav.catalog",
    requires: { permission: "catalog:read", scope: "all" },
  },
  {
    key: "commission",
    path: "/commission/rates",
    labelKey: "nav.commissionRates",
    requires: { permission: "commission:read", scope: "all" },
  },
  {
    key: "catalog-mgmt",
    path: "/catalog/management",
    labelKey: "nav.catalogMgmt",
    requires: { permission: "catalog:read", scope: "all" },
  },
  {
    // Müşteriler — customer (party) management: list/search, detail + name/email edit,
    // and step-up'd password reset. Visible to any staff holding party:read (advisors
    // see their own book at scope=own; the API re-enforces the scope on every call).
    key: "customers",
    path: "/customers",
    labelKey: "nav.customers",
    requires: { permission: "party:read", scope: "own" },
  },
  {
    // Ekip — IAM staff provisioning (#211): create a new staff login (advisor / manager /
    // admin). Visible to any staff holding staff:write@all (ADMIN + SUPER_ADMIN); the
    // elevated-role options within re-gate on staff.admin:write, and the API re-enforces
    // every call regardless.
    key: "iam",
    path: "/iam",
    labelKey: "nav.iam",
    requires: { permission: "staff:write", scope: "all" },
  },
  {
    // KVKK — Veri-sahibi talepleri (DSAR register). The compliance desk: log / list /
    // advance data-subject requests (KVKK m.11/m.13). Visible to any staff holding
    // dsar:read@all (COMPLIANCE); the create + status actions re-gate on dsar:write and
    // the API re-enforces every call regardless.
    key: "dsar",
    path: "/kvkk",
    labelKey: "nav.dsar",
    requires: { permission: "dsar:read", scope: "all" },
  },
  {
    // U10-REPORTS-F — the management pilot-scorecard dashboard. Visible only to the
    // cross-advisor analytics grant; the six metrics reads re-enforce it server-side.
    key: "reports",
    path: "/reports/pilot",
    labelKey: "nav.reports",
    requires: { permission: "analytics:read", scope: "all" },
  },
  {
    // Marketing konsolu (MK-1/MK-2). Consent-audience ledger + attribution (reads)
    // and consent-bounded campaign definition/resolve. Visible on marketing:read@all;
    // campaign writes re-gate on marketing:manage@all. SEND IS DEFERRED.
    key: "marketing",
    path: "/marketing",
    labelKey: "nav.marketing",
    requires: { permission: "marketing:read", scope: "all" },
  },
  {
    key: "config",
    path: "/config/governance",
    labelKey: "nav.config",
    requires: { permission: "config:read", scope: "all" },
  },
];

export { visibleSurfaces };
